// @flow
import React from 'react'
import colors from '../../styles/colors'

function renderErrors(errors, name) {
  if (!errors || !errors[name]) return false

  return errors[name].map((error, i) => (
    <div key={i} style={{ fontSize: '85%', color: colors.danger }}>
      {`${name.charAt(0).toUpperCase()}${name.substring(1)} ${error}`}
    </div>
  ))
}

type Props = {
  name: string,
  errors: any
}

const Errors = ({ errors, name }: Props) => (
  <div>{renderErrors(errors, name)}</div>
)

export default Errors



// WEBPACK FOOTER //
// ./src/components/Errors/index.js